export default __webpack_public_path__ + "static/guests-pc-2b7e065479d4a0e3a1de223ba5fd0aec.png";